import { Component, OnInit } from '@angular/core';

@Component({
  selector: 's18-event-context-menu',
  templateUrl: './event-context-menu.component.html',
  styleUrls: ['./event-context-menu.component.scss']
})
export class EventContextMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
